import { Box } from '@chakra-ui/react'
import _ from 'lodash'
import { ItListItem } from 'types/graphql'

import { useFormContext } from '@redwoodjs/forms'

import { isEmpty } from '..'

import ScraperInner from './ScraperInner/ScraperInner'

export type ScraperProps = {
  onBeforeUpdate?: (item: ItListItem) => ItListItem
  hasError?: boolean
  children: React.ReactNode
}

const Scraper: React.FC<ScraperProps> = ({ children, ...props }) => {
  const { watch } = useFormContext<ItListItem>()
  const item = watch()
  if (isEmpty(item)) {
    return (
      <ScraperInner {...props} item={item}>
        {children}
      </ScraperInner>
    )
  } else {
    return <Box>{children}</Box>
  }
}
export default Scraper
